/**
 * 화면 밖 적의 표지에 무엇을 적을까(`Hud.pointToEnemies`). 그림을 모르는 셈만 둔다(시험이 본다).
 *
 * 처음에는 화면 안에 적이 **하나도 없을 때만** 표지를 띄웠다. 적이 횡대로 오게 된 뒤(Todo11) 폰 세로 화면에서는 대열의
 * 한쪽만 화면에 걸리는 일이 잦다 — 그때 표지가 꺼져, 화면 밖에 얼마나 더 있는지 알 길이 없었다(QA가 짚었다: "적 일부가
 * 화면 밖인데도 표지가 안 보인다").
 */

/** 화면 안에 적이 있을 때, 화면 밖의 적이 살아 있는 적의 이 몫 이상이어야 표지를 띄운다(백분율). */
export const MARKER_OFF_PCT = 25;
/** 그리고 이 수 이상이어야 한다 — 한둘이 화면 가장자리를 드나들 때마다 표지가 깜박이면 시끄럽다. */
export const MARKER_OFF_MIN = 3;
/**
 * 이미 떠 있는 "+N" 표지는 이 몫·이 수 아래로 내려가야 꺼진다. 켜는 문턱 하나만 두었더니 화면 밖이 문턱 언저리(32명
 * 가운데 7~8명)를 오르내릴 때 한 틱 꺼졌다 다시 켜졌다(QA).
 */
export const MARKER_KEEP_PCT = 15;
export const MARKER_KEEP_MIN = 2;

/**
 * 표지의 글. 띄우지 않으면 null.
 * - 화면 안에 적이 하나도 없으면 살아 있는 적 전부: "적 12".
 * - 화면 안에도 있으면, 화면 밖이 충분히 많을 때만 그 수를 더하기로: "적 +5". `wasPlus`는 지난 프레임에 "+N"이 떠
 *   있었는가 — 떠 있었으면 더 낮은 문턱(`MARKER_KEEP_*`)까지 그대로 둔다.
 */
export function foeMarkerText(seen: number, off: number, wasPlus = false): string | null {
  if (off <= 0) return null;
  if (seen <= 0) return `적 ${off}`;
  const alive = seen + off;
  const min = wasPlus ? MARKER_KEEP_MIN : MARKER_OFF_MIN;
  const pct = wasPlus ? MARKER_KEEP_PCT : MARKER_OFF_PCT;
  if (off < min || off * 100 < alive * pct) return null;
  return `적 +${off}`;
}
